export enum EventMetaKey {
	FLAG_DONE = 'flag_done',
	MEDDIDENT_MEDICAL_EXAMINATION = 'meddident_medical_examination',
}
